import * as React from 'react';
import { Button, Popup } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { ActionWidget } from 'components/form/trident-campaigns';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import classnames from 'classnames';
import './FlowDesign.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import './widget.scss';

export default class RandomizerWidget extends React.Component<
  CampaignWidgetProps
> {
  render() {
    const { model, canActivate, currentNodeKey, parentKeyList } = this.props;
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.randomizer, _.get(model, 'nodesOccMap'));
    const parentHasChildren =
      _.get(this.props.model.nodes[parentKey], 'children', []).length > 1;

    return (
      <div
        className={classnames('entry', 'randomizerNode', {
          sole: !parentHasChildren,
        })}
      >
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button
                className={classnames('button', {
                  buttonClicked:
                    this.props.clickedNode === this.props.currentNodeKey,
                })}
                onClick={() =>
                  this.props.handleNodePreview(ancestorList, currentNodeKey)
                }
              >
                {_.get(model.nodes[currentNodeKey], 'name', defaultName) ||
                  defaultName}
              </Button>
            }
            content={getNodePopupContent(
              model,
              'name',
              currentNodeKey,
              defaultName,
            )}
          />
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 && (
          <div className={'noDropdownButton'}>
            {_.get(model.nodes[currentNodeKey], 'children', []).map(
              (childKey, index) => {
                return (
                  <ActionWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    childIndex={index}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    parentKeyList={ancestorList}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              },
            )}
          </div>
        )}
      </div>
    );
  }
}
